import { createContext } from 'react';

const VacanciesContext = createContext(void 0);

VacanciesContext.displayName = 'context(vacancies)';

export default VacanciesContext;